<template>
  <div class="boxResumo">
    <Topo class="naoImprimir" :btnLogout="true" :acessoRestritoMenu="false"></Topo>
    <Migalha class="naoImprimir" label="Resumo do Cadastro do Fornecedor"></Migalha>
    <CabecalhoImpressao class="imprimir" hidden></CabecalhoImpressao>
    <br>
     <v-layout row d-inline class="p-t-30">
       <v-flex xs12>
        <div class="right p-l-10">
          <v-btn slot="activator" color="primary" class="mb-2" v-print>Imprimir
            <v-icon dark right>print</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="$verificaPerfilHabilitador()" >
        <div class="right p-l-10">
        <v-btn
          slot="activator"
          color="primary"
          class="mb-2"
          @click="$router.go(-1)"
        >Voltar</v-btn>
        </div>
      </v-flex>      
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 md6 class="textoBoasVindas">
        <div v-show="!$route.params.id">
          <h1 class="text-red">
            <strong class="text-uppercase">{{$t('label.cadastro')}}</strong>
          </h1>
          <!-- <h4 class="text-primary">
          <strong>
            {{$t('titulo.seuNumeroDeSolitacao')}}:<br>
            <span class="green--text">{{model.numSolicitacao}}</span>
          </strong>
          </h4>-->
          <div class="tituloStatusCadastro text-md-center font-size-18">
            <strong>
              {{$t('titulo.statusSituacaoSolicitacao')}}:
              <br />
              <span
                class="text-atencao"
              >{{retornaEnumDescricao("situacaoFornecedor",model.sitFornecedor)}}</span>
            </strong>
          </div>
        </div>

        <div v-show="$route.params.id">
          
          <h1 class="text-red">
            <strong class="text-uppercase">Solicitação</strong>
          </h1>

          <div class="tituloStatusCadastro text-md-center font-size-18">
            <strong>
              O Status da Solicitação é:
              <br />
             
              <span v-bind:class="{
                'red--text':(retornaEnumChave('situacaoSolicitacao', model.situacaoSolicitacao) == 'Indeferida'),
                'green--text':(retornaEnumChave('situacaoSolicitacao', model.situacaoSolicitacao) == 'Deferida'),
                'text-atencao':(retornaEnumChave('situacaoSolicitacao', model.situacaoSolicitacao) == 'EmAnalise'),
                'text-primary':(retornaEnumChave('situacaoSolicitacao', model.situacaoSolicitacao) == 'AguardandoAnalise'),
                
                }">{{this.retornaEnumDescricaoSolicitacao("situacaoSolicitacao", model.situacaoSolicitacao)}}</span>
            </strong>
          </div>
        </div>
      </v-flex>
      
    </v-layout>
    <dadosBasicos :model="model" :enums="enums" :dominio="dominio" v-if="modelCarregado"></dadosBasicos>

    <resumoDocsRejeitados :model="model" v-if="modelCarregado"></resumoDocsRejeitados>
    
    <br><br><br>
    <RodapeImpressao class="imprimir" hidden></RodapeImpressao>
  </div>
</template>

<script>
import fornecedorService from "../../../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */
import dominioService from "../../../services/dominioService";
import Migalha from "../../../components/migalha";
import Topo from "../../../components/Topo";
import CabecalhoImpressao from "../../../components/cabecalho-impressao";
import RodapeImpressao from "../../../components/rodape-impressao";
import dadosBasicos from "./resumo-dados-basicos";
import familia from "./resumo-familia";
import qualificacaoTecnica from "./resumo-qualificacao-tecnica";
import habilitacaoJuridica from "./resumo-habilitacao-juridica";
import regularidadeFiscal from "./resumo-regularidade-fiscal";
import qualificacaoEconomica from "./resumo-qualificacao-economica";
import formulariosDeclaracoes from "./resumo-formularios-declaracoes";
import alteracoesGrid from "./resumo-alteracoes";
import resumoDocsRejeitados from "./resumo-docs-rejeitados";
import util from "../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
import Print from "vue-print-nb";
import Vue from "vue";

export default {
  name: "fornecedor-resumo",
  mixins: [util],
  components: { /*Componentes utilizados*/
    //mascote,
    Migalha,
    Topo,
    dadosBasicos,
    habilitacaoJuridica,
    familia,
    qualificacaoTecnica,
    regularidadeFiscal,
    qualificacaoEconomica,
    formulariosDeclaracoes,
    alteracoesGrid,
    resumoDocsRejeitados,
    CabecalhoImpressao,
    RodapeImpressao
  },

  data() {//Declaracao de variaveis
    return {
      enums: {
        tipoCertificado: []
      },
      valid: true,
      model: {},
      OldModel: {},
      alteracaoModel: {},
      dominio: {
        categoria: [],
        paises: []
      },
      mascote: {
        msg: "Envio realizado com sucesso.",
        percent: 0
      },
      modelCarregado: false
    };
  },

  created() /*Metodo de start do componente*/{
    this.inicializar();
    Vue.use(Print);
  },
  methods: {//Declaracao de todos os metodos
    inicializar() {
      if (this.$route.params.id) {
        this.visualizarSolicitacao();
      } else {
        this.getFornecedorSIMPAS();
      }
      this.getCombosDadosBasicos();
      dominioService.geEnums().then(response => { /*resposta do servico*/
        this.enums = response.data; /*dados de retorno*/
      });
    },

    getCombosDadosBasicos() {
      //caregar combos de dados basicos
      dominioService.getCombosDadosBasicos().then(response => { /*resposta do servico*/
        this.dominio = response.data; /*dados de retorno*/
      });
    },

    getFornecedorSIMPAS() {
      //resgatar dados do fornecedor
      this.$mostrarPreload(); /*Exibir o PreLoad*/
      const numCgcFornecedor =
        this.$route.params.id && this.$verificaPerfilHabilitador()
          ? this.$route.params.id
          : null;
      fornecedorService.getFornecedorSIMPAS(numCgcFornecedor).then(response => { /*resposta do servico*/
        this.model = response.data; /*dados de retorno*/
        this.modelCarregado = true;
        this.$removePreload(); /*Ocultar o PreLoad*/
      });
    },

    visualizarSolicitacao() {
      //visualizar a solicitcao
      this.$mostrarPreload(); /*Exibir o PreLoad*/
      fornecedorService
        .getResumoSolicitacao(this.$route.params.id)
        .then(response => { /*resposta do servico*/
          this.model = response.data.novoModel ? response.data.novoModel : response.data; /*dados de retorno*/
          this.OldModel = response.data.oldModel ? response.data.oldModel : {};
          this.alteracaoModel = response.data.alteracao ? response.data.alteracao : {};
          this.modelCarregado = true;
          this.$removePreload(); /*Ocultar o PreLoad*/
        })
        .catch(error => {
            this.$removePreload(); /*Ocultar o PreLoad*/
            if (error.status == 403) {
                Vue.toasted.error("Acesso não permitido!");
                this.$router.push("/historico-solicitacoes");
            }
        });
    },
    retornaEnumChave(_enum, valor) {
      //retorna a chave do enum
      if (valor == null || this.enums[_enum] == null) return "";
      let retorno = this.enums[_enum].find(x => x.valor === valor);
      return retorno ? retorno.chave : null;
    },

    retornaEnumDescricao(_enum, valor) {
      //retorna a descricao do enum
      if (valor == null || !this.enums[_enum] == null) return "";
      let retorno = this.enums[_enum].find(x => x.valor === valor);
      return retorno ? retorno.descricao : null;
    },

    retornaEnumDescricaoSolicitacao(_enum, valor) {
      //retorna a descricao do enum da Solicitacao
      if (valor == null || !this.enums[_enum] == null) return "";
      let retorno = this.enums[_enum].find(x => x.valor === valor);
      if (retorno){
          if (retorno.descricao === 'Atualizada'){
              return 'Deferida';
          }else if(retorno.descricao === 'Atualizada com Ressalvas'){
              return 'Deferida Parcial';
          }else{
            return retorno.descricao;
          }    
      }else {
        return null;
      }
    },

    retornaCategoria(cod_categoria) {
      //retorna a categoria
      if (!cod_categoria) return "";
      let categoria = this.dominio.categoria.find(
        x => x.categoria === cod_categoria
      );
      return categoria ? categoria.descricao : null;
    }
  }
};
</script>
<style scoped> /*CSS especifico do componente*/
.textoBoasVindas h1 {
  font-size: 40px;
}

.nomeFornecedor {
  position: relative;
}

.boxConteudoNomeFornecedor {
  background: url("/images/bg1.png") repeat center center;
  border: 1px solid #cdcdcd;
  position: absolute;
  text-align: center;
  top: 50%;
  transform: translateY(-25%);
  width: calc(100% - 30px);
  z-index: 999;
  padding: 10px 0;
}
</style>
<style scoped> /*CSS especifico do componente*/
.theme--light.v-table thead {
  background: none;
  color: red;
}
</style>


<style>
.boxResumo .theme--light.v-table thead {
  background: none;
}
.dataVencida {
  color: red !important;
}
</style>
